import { Button } from "devextreme-react/button";
import { Item, Toolbar } from "devextreme-react/toolbar";
import { useContext } from "react";
import { CompanyTypes, KindOfOrder } from "../../../../types/enums";
import { showErrorMessage } from "../../../../utils/messages";
import NoteGrid from "../../../common/notes/components/NoteGrid";
import { useMarkStoreNoteAsRead } from "../../notes/api/mark-store-note-as-read";
import { RefetchScope, WorkOrderContext } from "../context/WorkOrderContext";
import WorkOrderAddNoteButton from "./WorkOrderAddNoteButton";

export default function WorkOrderNotes() {

	const { order, refetchOrder } = useContext(WorkOrderContext);

	const markNoteAsRead = useMarkStoreNoteAsRead(
		() => { refetchOrder(RefetchScope.Notes) },
		(error) => showErrorMessage(error));

	return (
		<>
			<Toolbar className='button-toolbar note-button-toolbar'>
				<Item location={'before'}>
					<WorkOrderAddNoteButton />
				</Item>
				<Item location={'after'}>
					{
						order.details.notes.find(x => x.createdByCompanyTypeID === CompanyTypes.DEALER && !x.readOn) &&
						<Button
							text="Mark All As Read"
							icon="Inscyth-Order-Material"
							disabled={markNoteAsRead.isLoading}
							onClick={() => {
								markNoteAsRead.mutate({ orderID: order.details.workOrderID, kindOfOrder: KindOfOrder.WorkOrder });
							}}>
						</Button>
					}
				</Item>
			</Toolbar>
			<NoteGrid
				notes={order.details.notes}
				showMarkAsReadCompanyTypeID={CompanyTypes.DEALER}
				onMarkNoteAsRead={(noteID: number) => {
					markNoteAsRead.mutate({ noteID: noteID });
				}}
			/>
		</>
	)
}
